module.exports = __webpack_public_path__ + "static/media/l_o_s.9fb5b985.gif";